import { Paginator } from "~/@shared/api-types/Paginator"
import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"

import { RecruitmentStatus } from "../_common/types-for-recruitment"

const PATH = "/short-internships"

type GetShortInternshipsQuery = { page?: number }
type GetShortInternships = Paginator<ShortInternship>

export const fetchGetShortInternships = defineFetcher(
  (query: GetShortInternshipsQuery): Promise<GetShortInternships> => {
    return GET(PATH, query)
  }
)

interface ShortInternship {
  id: number
  title: string
  job_type: string
  status: RecruitmentStatus
  category_name: string
  category_display: string
  thumbnail_img_url: string
  url: string
  company: Company
}

interface Company {
  id: number
  display: string
  main_img_url: string
  company_overview: string
}
